import { Tooltip } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router";

import arrow from "../../../Assets/img/stakingrisk/arrow.svg";
import { stakingRiskTooltips } from "../../../Utils/stakingrisk_tooltipTexts";
import style from "./staking-risk.module.css";
import { getValueColor } from "./helper";

const coldprops = {
  colorSlice: "#4DC7B5",
  fontColor: "#4DC7B5",
  fontSize: "1.625em",
  fontWeight: 900,
  size: 112,
  boxShadow: "inset 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 16%)",
  unit: "",
  textPosition: "0.35em",
  animationOff: false,
  inverse: false,
  round: true,
  number: false,
};

const riskprops = {
  colorSlice: "#EFB661",
  fontColor: "#EFB661",
  fontSize: "1.625em",
  fontWeight: 900,
  size: 112,
  boxShadow: "inset 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 16%)",
  unit: "",
  textPosition: "0.35em",
  animationOff: false,
  inverse: false,
  round: true,
  number: false,
};

const holdprops = {
  colorSlice: "#F27281",
  fontColor: "#F27281",
  fontSize: "1.625em",
  fontWeight: 900,
  size: 112,
  boxShadow: "inset 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 16%)",
  unit: "",
  textPosition: "0.35em",
  animationOff: false,
  inverse: false,
  round: true,
  number: false,
};

const whiteprops = {
  // percent: 0, // is require
  colorSlice: "#f0f0f3",
  fontColor: "#f0f0f3",
  fontSize: "1.625em",
  fontWeight: 900,
  size: 112,
  boxShadow: "inset 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(0 0 0 / 16%)",
  unit: "",
  textPosition: "0.35em",
  animationOff: false,
  inverse: false,
  round: true,
  number: false,
};
const renderClassName = (level) => {
  switch (level) {
    case "Low Risk":
    case "Low – Medium Risk":
      return {
        className: "card cold defi",
        color: "#4dc7b5",
        props: coldprops,
      };
    case "Medium Risk":
      return {
        className: "card hold defi",
        color: "#EFB661",
        props: riskprops,
      };
    case "High Risk":
    case "Medium – High Risk":
      return {
        className: "card risky defi",
        color: "#F27281",
        props: holdprops,
      };
    default:
      return {
        props: whiteprops,
        color: "#C4C4C4",
        className: "card empty defi",
      };
  }
};
export default function ProductCard({ onSelect, product = {} }) {
  const cards = product?.stakingRisk?.stakingRiskClassifications ?? [];
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  return (
    <div className={style["card-wrapper"]}>
      {Array.isArray(cards) && cards?.map((card, index) => {
        const normalizedName = card.key.toLowerCase().trim();
        return (
          <div key={index} className={style["card"]} >
            <div className={style["card-header"]} style={{ paddingTop: "10px" }}
              onClick={() => {
                navigate(`/staking-risk/details/${product?.id}`, {
                  state: { selectedProduct: card, sc: "4444" }
                })
              }}>
              <div>
                <h3>
                  {card.name}{" "}
                  <Tooltip
                    placement="rightTop"
                    title={<div
                      dangerouslySetInnerHTML={{
                        __html:
                          stakingRiskTooltips[normalizedName]?.text
                            ?.replace(/\n/g, "<br/>"),
                      }}
                    />}
                    color={"#364048"}
                    onOpenChange={(visible) => setVisible(visible)}
                    overlayInnerStyle={{ width: "350px", height: "auto" }}
                  >
                    <i
                      className="icon-Vector"
                      style={{ position: "relative", left: "1%", top: "2px" }}
                    ></i>
                  </Tooltip>
                </h3>
                <span
                  className={style["level"]}
                  style={{
                    color: renderClassName(
                      card.riskScoreType === "manual"
                        ? card.manualScoreLevel
                        : card.automaticScoreLevel
                    ).color
                  }}>
                  {card.riskScoreType === "manual"
                    ? card.manualScoreLevel
                    : card.automaticScoreLevel}
                </span>

              </div>
              <div className={style["arrow"]}
                onClick={() => {
                  navigate(`/staking-risk/details/${product?.id}`, {
                    state: { selectedProduct: card }
                  });
                }}>
                <img
                  src={arrow}
                  alt="Arrow"
                  style={{ transform: "rotate(180deg)" }}
                />
              </div>
            </div>
            <div className={style["line"]}></div>
            <div className={style["card-header"]}>
              <div>
                <h3 className={style["w-score"]}>% of Total Score:</h3>
              </div>
              <div>
                <span className={style["w-scorevalue"]}>{card.totalScore}%</span>
              </div>
            </div>
            <div className={style["line"]}></div>
            <div className={style["card-header"]}>
              <div>
                <h3 className={style["w-score"]}>Weighted Risk:</h3>
              </div>
              <div>
                <span className={style["w-scorevalue"]}>{card.weightedScore}%</span>
              </div>
            </div>
            <div className={style["line"]}></div>
            <div className={style["card-header"]}>
              <div>
                <h3 className={style["w-score"]} style={{ padding: "10px 0" }}>
                  Classification:
                </h3>
              </div>
            </div>
            <div className={style["card-content-wrapper"]}>
              {Array.isArray(card.stakingRiskAssessments) && card.stakingRiskAssessments.map((item, idx) => (
                <div
                  key={idx}
                  className={style["card-content"]}>
                  <div>
                    <h4 className={style["asset"]}>{item.name}</h4>
                  </div>
                  <div>
                    <span
                      className={style["level"]}
                      style={{
                        color:
                          getValueColor(item.scoreLevel, item.key) || "#e0e0e0",
                      }}>
                      {item.scoreLevel}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )
      })}
    </div>
  )
}